import { render, staticRenderFns } from "./EsgProtocolSubOrganizationSync.vue?vue&type=template&id=51d71641&scoped=true"
import script from "./EsgProtocolSubOrganizationSync.vue?vue&type=script&lang=js"
export * from "./EsgProtocolSubOrganizationSync.vue?vue&type=script&lang=js"
import style0 from "./EsgProtocolSubOrganizationSync.vue?vue&type=style&index=0&id=51d71641&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d71641",
  null
  
)

export default component.exports